export default __webpack_public_path__ + "static/media/Delete-Icon.7c7e605e.svg";